import React from 'react';
import styled from 'styled-components';
import backIcon from 'images/chevron-back-black.svg';

export const RoofingFormContainer = styled.div`
  width: 100%;
  height: auto;
  background: var(--white);
  box-shadow: 0px 15px 40px rgba(0, 0, 0, 0.1);

  .side {
    background: #f6f8fa;
  }

  .form-container {
    h4 {
      color: var(--Grey-8);
      text-align: center;
      font-family: 'Sofia Pro';
      line-height: 110%;
      letter-spacing: 0.8px;
      text-transform: uppercase;
    }
    h3 {
      font-family: 'Sofia Pro';
      line-height: 120%;
      letter-spacing: -1.12px;
    }
    p {
      font-family: 'Nunito Sans';
      line-height: 150%;
    }
    .MuiInputBase-root {
      width: 100%;
    }
  }

  .form-item {
    margin-bottom: 0;
  }

  .form-embed-link {
    margin: 0 auto;
    width: fit-content;
  }

  .form-field--label {
    font-size: var(--font-size-18) !important;
    font-weight: var(--font-weight-800) !important;
  }

  .form-field--label .form-field--helper {
    width: 16px;
    height: 16px;
    min-width: 16px;
    min-height: 16px;
    line-height: 16px;
    font-size: 11px;
    margin-left: 6px;
    margin-top: 2px;
  }

  @media (min-width: 767px) {
    .mobile-selector {
      display: none !important;
    }
  }
`;

export const FormContainer = styled.div`
  margin-top: ${(props) => (props.isEmbed ? '0 !important' : '75px')};

  .section-tool-page-form--container {
    max-width: 1046px;
    margin: 0 auto;
    padding: 0 28px;

    ${(props) => (props.isEmbed ? '& > div {box-shadow: none !important;}' : '')}
  }

  @media (max-width: 767px) {
    margin-top: 40px;

    .section-tool-page-form--container {
      padding: 0;

      .roofing-calc-type-selector .MuiInputBase-root {
        .MuiSelect-select.MuiInputBase-input {
          font-size: 23px;
          font-weight: 800;
          line-height: 120%;
          letter-spacing: -0.46px;
          padding: 10px 20px 6px;
        }

        .MuiSvgIcon-root {
          transform: scale(1.3);
          fill: var(--titan-blue-5);
        }
      }

      .form-field--input-container {
        margin-top: 10px;
      }
    }
  }
`;

export const BackButton = ({ onClick, btnText }) => (
  <button
    type="button"
    onClick={onClick}
    className="flex p-[14px_10px] md:p-[20px_48px] justify-center items-center gap-[10px] self-stretch border border-solid border-[#17191C] bg-transparent text-[var(--darkest)] cursor-pointer"
  >
    <span className="flex w-[25px] h-[25px] justify-center items-center">
      <img src={backIcon} alt="back" />
    </span>
    <span className="text-center font-['Sofia_Pro'] text-[20px] font-extrabold leading-[110%] tracking-[-0.2px] mb-[3px]">
      {btnText}
    </span>
  </button>
);
